const subject = encodeURIComponent('Contact Support');
const body = encodeURIComponent('Hi GeoBuyer Support,\n\nI need help with...');
const recipient = 'support@geobuyer.app';

export const GMAIL_LINK = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipient}&su=${subject}&body=${body}`;
export const OUTLOOK_LINK = `https://outlook.office.com/mail/deeplink/compose?to=${recipient}&subject=${subject}&body=${body}`;
export const YAHOO_LINK = `https://compose.mail.yahoo.com/?to=${recipient}&subject=${subject}&body=${body}`;
export const MAILTO_LINK = `mailto:${recipient}?subject=${subject}&body=${body}`;

export const DEFAULT_VAL = '';
export const PASS_LENGTH = 4;
